const baseStyleLink = {
    color: "primary.700",
    fontSize: "sm",
    _visited: {
        color: "primary.500",
        _hover: {
            color: "primary.600",
        },
    },
    _activeLink: { pointerEvents: "none" },
    _hover: {
        textDecoration: "none",
    },
    _active: {
        color: "primary.700",
    },
    _focus: {
        boxShadow: "none",
    },
};
const baseStyle = {
    link: baseStyleLink,
};
const Breadcrumbs = {
    baseStyle,
};
export default Breadcrumbs;
